module.exports = __webpack_public_path__ + "img/icon2.a7f754e2.gif";